<template>
    <v-container fluid>
        <page-header title="League Groups" icon="mdi-group">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createLeagueGroup">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="leagueGroups"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
        />
    </v-container>
</template>

<script>
    import leagueGroupService from '@/services/leagueGroup'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'LeagueGroups',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                leagueGroups: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Title',
                        value: 'title'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    }
                ],
                tableKey: 'leagueGroups',
                filterFields: [
                    { key: 'title', label: 'Title', type: 'text' },
                    { key: 'active', label: 'Active', type: 'boolean' }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/league-groups/${item.id}/${action}`)
            },
            onDelete(item, page) {
                leagueGroupService.deleteLeagueGroup(item.id).then(() => {
                    this.page = page
                    this.fetchItems()
                })
            },
            createLeagueGroup() {
                this.$router.push(`/league-groups/create`)
            },
            fetchItems() {
                leagueGroupService.getFilteredLeagueGroups(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.leagueGroups = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
